<div class="progress-snackbar">
    <span>
        {{ "DOWNLOAD_SNACK_BAR.DOWNLOADING" | translate }} {{ progress }}%

        <button mat-button (click)="snackBarRef.dismiss()">
            {{ "DOWNLOAD_SNACK_BAR.CANCEL" | translate }}
        </button>
    </span>
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>
